import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const KEY = "reader-selection-hint-dismissed-v1";

export default function SelectionHint({ selectMode }) {
    const [hidden, setHidden] = useState(true);

    useEffect(() => {
        try {
            setHidden(localStorage.getItem(KEY) === "1");
        } catch (_e) { setHidden(false); }
    }, []);

    if (hidden || selectMode) return null;

    const dismiss = () => {
        try { localStorage.setItem(KEY, "1"); } catch (_e) { /* ignore */ }
        setHidden(true);
    };

    return (
        <div
            data-testid="selection-hint"
            className="mx-5 md:mx-8 mt-3 px-3 py-2 rounded-full bg-moss/8 border border-moss/20 flex items-center gap-2"
        >
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-moss-deep" aria-hidden />
            <span className="font-ui text-[12px] text-ink-70 flex-1">
                Long-press a verse — or use the <span className="font-semibold text-moss-deep">Select</span> button — to highlight and take notes.
            </span>
            <button
                data-testid="dismiss-selection-hint"
                onClick={dismiss}
                aria-label="Dismiss hint"
                className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-ink-40 hover:text-ink hover:bg-ink-10 transition"
            >
                <X size={12} />
            </button>
        </div>
    );
}
